import React, { useState } from 'react';
import { Button, Tooltip } from 'antd';
import { UploadSimple } from 'assets/images/icons';
import UploadHostedLookupTable from './UploadHostedLookupTable';
import hostedTablesActions from 'redux/hostedTables/actions';
import { connect } from 'react-redux';
import { HOSTED_TABLE_TABS } from './HostedLookupTablesList';

const AddHostedLookupTable = ({ disabled, uploadPopupVisible, setUploadPopupVisible, maxTablesCount, tableNames,activeTab, conversationTableNames}) => {
  const selectedTableName = activeTab === HOSTED_TABLE_TABS.CONVERSATIONAL_TABLES ? conversationTableNames : tableNames;

  return (
    <>
      <Tooltip
        title={selectedTableName.length >= maxTablesCount ? "Maximum Tables limit exceeded, delete existing one to add new" : ""}
        placement="left"
      >
        <Button
          type="primary n-btn"
          className="sg-button sg-primary"
          onClick={() => setUploadPopupVisible(true)}
          disabled={disabled || selectedTableName.length >= maxTablesCount}
          icon={<UploadSimple className="upload__svg" />}
        >
          Upload
        </Button>
      </Tooltip>
      <UploadHostedLookupTable
        isVisible={uploadPopupVisible}
        activeTab={activeTab}
      />
    </>
  );
};

const mapStatetoProps = (state) => ({
  tableNames: state.hostedTables.tableNames,
  uploadPopupVisible: state.hostedTables.uploadPopupVisible,
  maxTablesCount: state.hostedTables.maxTablesCount,
  conversationTableNames: state.hostedTables.conversationTableNames
});

const mapDispathTopProps = (dispatch) => ({
  setUploadPopupVisible: (uploadPopupVisible) => dispatch(hostedTablesActions.setUploadPopupVisible(uploadPopupVisible)),
});

export default connect(mapStatetoProps, mapDispathTopProps)(AddHostedLookupTable);
